import { useAuthStore } from "@/state/pinia";
import { canCategoryPersonTypeOperation } from "@/helpers/middleware_func";


export default (to, from, next, params) => {
    const authStore = useAuthStore();

    if (!authStore.loggedIn) {
        next({ name: 'login' });
        return;
    }

    const hasRequiredPermissions = canCategoryPersonTypeOperation(params);
    
    if (!hasRequiredPermissions) {
        next({ name: 'Error-404' });
        return;
    }
};


// export default (to, from, next, params) => {
//     const authStore = useAuthStore();

//     if (!authStore.loggedIn) {
//         next({ name: 'login' });
//         return;
//     }

//     // Parse params - can be array or string with comma/OR separators
//     const rawParams = Array.isArray(params)
//         ? params
//         : String(params ?? '').split(',');

//     const normalizedParams = rawParams
//         .map((param) => String(param ?? '').trim())
//         .filter(Boolean);

//     if (!normalizedParams.length) {
//         next({ name: 'Error-404' });
//         return;
//     }

//     const user = authStore.getUser;
//     let hasRequiredPermissions = false;

//     // Check each parameter (supports both comma-separated AND logic and pipe-separated OR logic)
//     for (const param of normalizedParams) {
//         // Split by pipe for OR logic within each parameter
//         const orConditions = param.split('|').map(p => p.trim()).filter(Boolean);

//         let paramSatisfied = false;

//         for (const condition of orConditions) {
//             // Parse category-personTypeId-operation format
//             const parts = condition.split('-');
//             if (parts.length !== 3) continue;

//             const category = String(parts[0]).trim();
//             const personTypeId = String(parts[1]).trim();
//             const operation = String(parts[2]).trim().toUpperCase();

//             if (category && personTypeId && operation &&
//                 user.hasCategoryPersonTypeOperation(category, personTypeId, operation)) {
//                 paramSatisfied = true;
//                 break; // Found one that works in OR condition
//             }
//         }

//         if (!paramSatisfied) {
//             // This parameter (comma-separated group) failed - whole check fails
//             hasRequiredPermissions = false;
//             break;
//         } else {
//             hasRequiredPermissions = true;
//         }
//     }

//     if (!hasRequiredPermissions) {
//         next({ name: 'Error-404' });
//         return;
//     }
// };